/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import { UserFlags } from 'cio/models/user';

export interface DependentUserFlagFeature {
  title: string;
  description: string;
  key: keyof UserFlags;
  hasPermission: boolean;
}

interface ExperimentalUserFlagFeatureArgs {
  title: string;
  description: string;
  key: keyof UserFlags;
  dependentFlags?: DependentUserFlagFeature[];
  disabled?: boolean;
  requiresFeedbackOnDisable?: boolean;
}

export default class ExperimentalUserFlagFeature extends Component<ExperimentalUserFlagFeatureArgs> {
  @service auth!: AuthService;

  get disabled() {
    return this.args.disabled === true;
  }

  get hideToggle() {
    return this.args.key == null;
  }
}
